import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, TextField } from '@mui/material';
import { useStyles } from "./style";
import { useState } from 'react';
import LabService from 'services/LabService';
import { buildQueryParams } from 'utils/common';
import MaterialTable from 'material-table';
import { toast } from 'react-toastify';
import _ from 'lodash';

const TestTab = props => {
    const classes = useStyles();
    const [disabled] = useState(false);
    const [testId, setTestId] = useState();
    const [email, setEmail] = useState();
    const [testName, setTestName] = useState();
    const [cleanUpRespnse, setCleanUpResponse] = useState([]);
    const labServiceObj = useMemo(() => new LabService(), []);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    useEffect(() => {
        try {
           
            const labParams = {
                lab : props?.labId
            }
            labServiceObj.getInvokeLabCleanUp(buildQueryParams(labParams)).then(response => {
                if (response) {
                    setCleanUpResponse(response?.data?.results)
                }
                labServiceObj.getLabCleanUpSetup(buildQueryParams(labParams)).then(response=>{
                    if(response){
                        setTestId(response?.data?.results[0]?.test_id)
                        setEmail(response?.data?.results[0]?.email)
                        setTestName(response?.data?.results[0]?.test_name)
                    }
                })
            })
        } catch (error) {
            console.log(error);
        }
    }, [props?.labId, labServiceObj])

    const columns = [
        {
            title : "Clean Up Start Date", field:"created_date", render: rowData => {
                const date = new Date(rowData.created_date);
                return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
              },
        }
    ]
    const subTablecolumns = [
        { title: "Suite", field: "Test Suite" },
        { title: "Group", field: "Test Case" },
        { title: "Task", field: "Test" },
        { title: "Start Time ", field: "Start Time", render: rowData => new Date(rowData['Start Time']).toUTCString() },
        { title: "End Time", field: "End Time", render: rowData => new Date(rowData['End Time']).toUTCString() },
        { title: "Status", field: "Status", render: (rowData) => {
            const statusColor = rowData.Status === 'PASS' ? 'green' : 'red';
            return (
              <span style={{ color: statusColor }}>{rowData.Status}</span>
            );
          } },
    ];

    const validatePayload = () => {
        if (_.isEmpty(testId)) {
            toast.error("Please enter TestID");
            return false
        } else {
            if (_.isEmpty(email) || emailRegex.test(email) === false) {
                toast.error("Please enter valid Email ID.");
                return false;
            } else {
                if (_.isEmpty(testName)) {
                    toast.error("Please enter valid Test Name.");
                    return false;
                }
            }
            return true;
        }



    }

    const invokeLabCleanupSetup = () => {
        const validInput = validatePayload()
        if (validInput) {
            const payload = {
                lab: props?.labId,
                test_id: testId,
                email: email,
                test_name: testName
            }
            labServiceObj.createLabCleanUpSetup(payload).then(response => {
                if (response) {
                    toast.success("Test Saved Succesfully.")
                }
            })
        }

    }
    


    return (
        <div>
            <Grid container spacing={3} style={{paddingLeft:"20px"}}>
                <Grid item xs={2}>
                    <TextField fullWidth
                        name="TestID"
                        label="CleanUp ID"
                        variant="outlined"
                        disabled={disabled}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setTestId(e.target.value)

                        }}
                        value={testId} />
                </Grid>
                <Grid item xs={3}>
                    <TextField fullWidth
                        name="Email"
                        label="Email"
                        variant="outlined"
                        disabled={disabled}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setEmail(e.target.value)

                        }}
                        value={email} />
                </Grid>
                <Grid item xs={3}>
                    <TextField fullWidth
                        name="TestName"
                        label="CleanUp Name"
                        variant="outlined"
                        disabled={disabled}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setTestName(e.target.value)

                        }}
                        value={testName} />
                </Grid>
                <Grid item xs={2} style={{ paddingTop: "26px" }}>
                    <Button
                        variant="contained"
                        component="label" onClick={invokeLabCleanupSetup}>
                        Save </Button>
                </Grid>
            </Grid>
            <div style={{ maxWidth: '100%', padding: '20px' }}>
                <MaterialTable
                    columns={columns}
                    data={cleanUpRespnse}
                    title={"Clean Up Results"}
                    detailPanel={rowData=>{
                        if(rowData?.test_result_response.length > 0){
                            return(
                                <div>
                                   <MaterialTable
                                   columns={subTablecolumns}
                                   title={""}
                                   data={rowData?.test_result_response} >
                                     </MaterialTable> 
                                </div>
                            )
                           
                        }else{
                            return(<div>No Data found. Please check again.</div>)
                        }
                       
                    }}
                />
            </div>
        </div>
    );
};

TestTab.propTypes = {
    labId: PropTypes.any,
    testDetails: PropTypes.any,
};

export default TestTab;